import { criarParticipante } from '@/uteis/action/estrutura/participante'

export const criarEstruturaInativa = (estrutura) => {
  var destino = criarParticipante(estrutura.nomeEstrutura, estrutura.estruturaID, 'ID', estrutura.siglaEstrutura)
  destino.participantePai = criarParticipante(estrutura.participantePai.nomeEstrutura, estrutura.participantePai.estruturaID, 'ID', estrutura.participantePai.siglaEstrutura)
  return destino
}
